import {DndProvider} from 'react-dnd'
import {HTML5Backend} from 'react-dnd-html5-backend'

import {PlaceIdList} from '../../../plugins/plugins.types'
import Plugin from '../../common/Plugin/Plugin'

import QueueBuildList from './QueueBuildList/QueueBuildList'
import QueuePageHeader from './QueuePageHeader/QueuePageHeader'

export default function QueuePage() {
  return (
    <DndProvider backend={HTML5Backend}>
      <QueuePageHeader />
      <Plugin placeId={PlaceIdList.SAKURA_BEFORE_CONTENT} />
      <QueueBuildList />
    </DndProvider>
  )
}
